<template>
  <FormElement type="radio">
    <template slot="label">
      <span>{{ label }}</span>
    </template>

    <template slot="warning">
      <span class="-require" v-if="requires">*ต้องกรอกข้อมูล</span>
    </template>

    <template slot="controller">
      <slot name="controller" />
      <button id="restore-button" @click="selection = prev">
        <vs-icon icon="restore" size="small"></vs-icon>
      </button>
    </template>

    <div class="radio-box" v-if="options.length > 0">
      <div class="-input">
        <template v-for="(option, index) in options">
          <div class="--each" :key="index">
            <input
              type="radio"
              :id="option.value"
              :value="option.value"
              v-model="selection"
            />
            <label :for="option.value">{{ option.title }}</label>
          </div>
        </template>
      </div>
    </div>
  </FormElement>
</template>

<script>
import FormElement from '../form-element';

export default {
  components: {
    FormElement
  },
  props: {
    label: String,
    prop: String,
    options: Array,
    edata: {
      type: String,
      default: null
    },
    requires: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selection: "",
    prev: ""
  }),
  watch: {
    selection: function (val) {
      if (this.prop && val) {
        this.$emit("input", { prop: this.prop, data: val });
      }
    }
  },
  beforeUpdate() {
    if (this.edata !== null) {
      this.$set(this, 'selection', this.edata);

      if (this.prev === "") {
        this.$set(this, 'prev', this.edata);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.radio-box {
  & .-input {
    display: inline-flex;

    & .--each {
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      margin: 0.5rem;

      & span {
        line-height: 1rem;
        font-size: 1.4rem;
      }

      & input[type="radio"] {
        height: 2rem;
        width: 2rem;
        margin-right: 1rem;
      }
    }
  }
}

#restore-button {
  &:hover {
    color: green !important;
  }
}
</style>
